import { HouseSelectorPolygon } from './types';

export const drawPolygon = (
    context: CanvasRenderingContext2D,
    polygonObject: HouseSelectorPolygon,
) => {
    const polygon = new Path2D();
    polygonObject.polygonPx?.forEach((point, index) => {
        if (index === 0) polygon.moveTo(point.x!, point.y!);
        polygon.lineTo(point.x!, point.y!);
    });

    polygon.closePath();
    context.stroke(polygon);
    context.fill(polygon);

    polygonObject.path = polygon;
};
